export const ORGANISATION_GROUP_DETAILS_REQUEST = "ORGANISATION_GROUP_DETAILS_REQUEST";
export const ORGANISATION_GROUP_DETAILS_RECEIVE = "ORGANISATION_GROUP_DETAILS_RECEIVE";
export const ORGANISATION_GROUP_DETAILS_FAILURE = "ORGANISATION_GROUP_DETAILS_FAILURE";
export const RESET_ORGANISATION_GROUP_DETAILS = "RESET_ORGANISATION_GROUP_DETAILS";
